export type MarkStyle = "normal" | "muted" | "reference";

export function foldMarkStyle<A>(
  style: MarkStyle,
  pattern: { [K in MarkStyle]: () => A }
) {
  return pattern[style]();
}
